import React, { FC, MouseEventHandler } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { color, px } from "../../Configs/theme";
import CloseIcon from "@material-ui/icons/Close";
import { getColorRgbaFromHex } from "../../Helpers/ColorHelper";

interface Props {
	direction: "bottomRight" | "bottomLeft" | "topRight" | "topLeft" | "rightTop" | "rightBottom" | "leftTop" | "leftBottom";
	children: JSX.Element;
	onClose: MouseEventHandler;
	title: string;
}

export const InfoBox: FC<Props> = (props) => {
	const classes = useStyles();

	return <Box className={classes.container}>
		<Box className={classes.title}>
			<Box className={classes.wrap}>
				{props.title}
			</Box>
			<CloseIcon onClick={props.onClose} className={classes.icon}></CloseIcon>
		</Box>
		{props.children}
		<Box className={`${classes.carrot} ${props.direction}`}></Box>
	</Box>;
};

export default InfoBox;

const useStyles = makeStyles({
	container: {
		borderRadius: px.m,
		backgroundColor: color.card,
		padding: px.m,
		width: "100%",
		boxSizing: "border-box",
		boxShadow: "0 5px 15px " + getColorRgbaFromHex(color.grayBackground01, 0.43)
	},
	title: {
		display: "flex",
		fontWeight: "bold"
	},
	wrap: {
		flexGrow: 1
	},
	icon: {
		cursor: "pointer",
	},
	carrot: {
		width: 0,
		height: 0,
		position: "absolute",
		border: `${px.s} solid transparent`,
		'&.bottomRight': {
			borderTop: `${px.xl} solid ${color.card}`,
			bottom: `-${px.xl}`,
			right: `${px.xl}`,
		},
		'&.bottomLeft': {
			borderTop: `${px.xl} solid ${color.card}`,
			bottom: `-${px.xl}`,
		},
		'&.topRight': {
			borderBottom: `${px.xl} solid ${color.card}`,
			top: `-${px.xl}`,
			right: `${px.xl}`,
		},
		'&.topLeft': {
			borderBottom: `${px.xl} solid ${color.card}`,
			top: `-${px.xl}`,
		},
		'&.rightTop': {
			borderLeft: `${px.xl} solid ${color.card}`,
			top: `${px.xl}`,
			right: `-${px.xl}`,
		},
		'&.rightBottom': {
			borderLeft: `${px.xl} solid ${color.card}`,
			bottom: `${px.xl}`,
			right: `-${px.xl}`,
		},
		'&.leftTop': {
			borderRight: `${px.xl} solid ${color.card}`,
			top: `${px.xl}`,
			left: `-${px.xl}`,
		},
		'&.leftBottom': {
			borderRight: `${px.xl} solid ${color.card}`,
			left: `-${px.xl}`,
			bottom: `${px.xl}`,
		},
	}
});
